import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'; // Add FormGroup import
import { PersonaParticipacionSociedades } from 'src/app/models/participacion-sociedades.model';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { PersonaService } from 'src/app/services/persona.service';
import { StepperService } from 'src/app/services/stepper.service';

@Component({
  selector: 'app-participacion-sociedades',
  templateUrl: './participacion-sociedades.component.html',
  styleUrls: ['./participacion-sociedades.component.css']
})
export class ParticipacionSociedadesComponent implements OnInit {
  formArray: FormArray<FormGroup> = new FormArray<FormGroup>([]);
  participaciones: PersonaParticipacionSociedades[] = [];
  persona: any;
  formFirmado = false;
  private estadoSituacionGuid: string = '';
  constructor(private fb: FormBuilder, private stepperService : StepperService, private dataService: DataService, private personaService: PersonaService,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.personaService.persona$.subscribe({
      next: (persona) => {
        if (persona) {
          this.persona = persona;
          this.formArray = this.fb.array<FormGroup<any>>([]);
          this.estadoSituacionGuid = persona.estadoSituacion.guid;
          if(persona.estadoSituacion.personaParticipacionSociedades?.length > 0){
            for (let i = 0; i < persona.estadoSituacion.personaParticipacionSociedades?.length; i++) {
              this.agregarParticipacion(persona.estadoSituacion.personaParticipacionSociedades[i]);
            }
          }else{
            this.agregarParticipacion(null);
          }
          if (persona.estadoSituacion?.estadoFormularioSituacion == 'Firmado') {
            this.formFirmado = true;
            this.formArray.disable();
          }
        }
      },
      error: (err) => console.log(err)
    });
    
  }
  
  agregarParticipacion(participacion: any): void {
    if (this.formArray.length > 0 && this.formArray.at(this.formArray.length - 1).invalid) {
      this.formArray.at(this.formArray.length - 1).markAllAsTouched();
      return;
    }
    const nuevaParticipacion = this.fb.group({
      estadoSituacionId: new FormControl(this.estadoSituacionGuid),
      guid: new FormControl(participacion?.guid),
      razonSocial: new FormControl(participacion?.razonSocial, [Validators.required]),
      rut: new FormControl(participacion?.rut, [Validators.required, this.commonService.createRutValidator(), Validators.pattern(/^[1-9]\d*[-|‐]{1}[0-9kK]{1}$/)]),
      patrimonio: new FormControl(participacion?.patrimonio, [Validators.required]),
      porcentajeParticipacion:  new FormControl(participacion?.porcentajeParticipacion, [Validators.required, Validators.min(0.1), Validators.max(100), Validators.pattern(/^[0-9]+(\.[0-9]{1,2})?$/)]),
      montoParticipacion: new FormControl(participacion?.montoParticipacion, [Validators.required])
    });
    this.formArray.push(nuevaParticipacion);
  }

  eliminarParticipacion(index: number): void {
    if (index >= 0 && index < this.formArray.length) {
      this.formArray.removeAt(index);
    }
  }

  onSubmit() {
    if(this.persona.estadoSituacion?.estadoFormularioSituacion == 'Firmado'){
      this.stepperService.nextStep();  
      return;
    }
    if(this.formArray.length == 1 && this.formArray.at(0).get('razonSocial')?.value == null) {
      this.stepperService.nextStep();
      return;
    }
    if(!this.formArray.invalid) {
      this.removeNullGuid();
      const formData = this.formArray.value;
      var url = `estado-situacion/${this.personaService.getPersonaGuid()}/participacion-sociedades`;
      this.dataService.postData(formData, url).subscribe({
        next: (v) => {
            this.stepperService.nextStep();
        },
        error: (e) => console.log(e),
        complete: () => {
          this.personaService.setPersona();
        },
      });
    }else{
      this.formArray.markAllAsTouched();
    }
  }

  removeNullGuid() {
    for (let i = 0; i < this.formArray.length; i++) {
      if(this.formArray.at(i).get('guid')?.value == null) {
        this.formArray.at(i).removeControl('guid');
      }
    }
  }

  volver(){
    this.stepperService.prevStep();
  }
}